'use client';

import { FC } from 'react';
import { DialogFooterProps } from './DialogFooter.types';
import styles from './DialogFooter.module.css';

export const DialogFooter: FC<DialogFooterProps> = ({ children }) => {
  return <footer className={styles.dialogFooter}>{children}</footer>;
};
